import React from "react";
import img1 from "../assets/image_1.svg";
import linkedIn from "../assets/linkedin.svg";
import insta from "../assets/insta.svg";
import twitter from "../assets/twitter.svg";
import facebook from "../assets/facebook.png";
import messenger from "../assets/messenger.svg";
import youtube from "../assets/youtube.svg";
import gplay from "../assets/gplay.svg";
import apple from "../assets/appstore.svg";
import heart from "../assets/heart.svg";
import copyRight from "../assets/ic_baseline-copyright.svg";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaGooglePlay,
} from "react-icons/fa";

function Footer({ applink, nav, footer }) {
  return (
    <footer className="bg-gray-900 text-white p-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start">
        <div className="mb-4 md:mb-0">
          <h3 className="text-2xl font-bold mb-4">Fintra</h3>
          <p>Personalising Finance for India</p>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-1">Quick Links</h3>
          {nav && (
            <ul className="flex flex-col">
              <li>
                <a
                  href={nav[1].href}
                  className="mb-1 block"
                  rel="noopener noreferrer"
                >
                  {nav[1].caption ? nav[1].caption : "Link"}
                </a>
              </li>
              <li>
                <a
                  href={nav[2].href}
                  className="mb-1 block"
                  rel="noopener noreferrer"
                >
                  {nav[2].caption ? nav[2].caption : "Link"}
                </a>
              </li>
              <li>
                <a
                  href={nav[3].href}
                  className="mb-1 block"
                  rel="noopener noreferrer"
                >
                  {nav[3].caption ? nav[3].caption : "Link"}
                </a>
              </li>
              <li>
                <a
                  href={nav[4].href}
                  className="mb-1 block"
                  rel="noopener noreferrer"
                >
                  {nav[4].caption ? nav[4].caption : "Link"}
                </a>
              </li>
              <li>
                <a
                  href={nav[5].href}
                  className="block"
                  rel="noopener noreferrer"
                >
                  {nav[5].caption ? nav[5].caption : "Link"}
                </a>
              </li>
            </ul>
          )}
        </div>
        <div className="mr-6 mt-4 sm:mt-0 md:mb-0">
          <h3 className="text-lg font-bold mb-2">Follow Us</h3>
          <div className="flex space-x-4">
            <a
              href={footer?.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={24} />
            </a>
            <a href={footer?.twitter} target="_blank" rel="noopener noreferrer">
              <FaTwitter size={24} />
            </a>
            <a
              href={footer?.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href={footer?.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn size={24} />
            </a>
            <a href={footer?.youtube} target="_blank" rel="noopener noreferrer">
              <FaYoutube size={24} />
            </a>
          </div>
          <a href={footer?.google_play} target="_">
            <img className="w-20 h-20 cursor-pointer" src={gplay} alt="" />
          </a>
        </div>
      </div>
    </footer>
  );
  // return (
  //   <div className="flex-col bottom-0 h-fit rounded-tl-[15px] rounded-tr-[15px] bg-black bg-opacity-75 w-full p-3">
  //     <div className="flex gap-4">
  //       <div className="flex-col flex-1 place-content-evenly">
  //         <div className="text-white text-xs font-medium flex font-montserrat md:p-4">
  //           Address: Plot No, 4th Floor, Sri Dheera's North East, 101, Road
  //           Number,2, Kakatiya Hills, Madhapur, Telangana - 500033
  //         </div>
  //       </div>

  //       {nav && <div className="flex flex-col flex-1">
  //         <Link to={nav[1].href} className="font-medium text-xs text-white font-montserrat hover:text-[#00C6CA]">
  //           {nav[1].caption}
  //         </Link>
  //         <Link to={nav[2].href} className="font-medium text-xs text-white font-montserrat hover:text-[#00C6CA]">
  //           {nav[2].caption}
  //         </Link>
  //         <Link to={nav[3].href} className="font-medium text-xs text-white font-montserrat hover:text-[#00C6CA]">
  //           {nav[3].caption}
  //         </Link>
  //         <Link to={nav[4].href} className="font-medium text-xs text-white font-montserrat hover:text-[#00C6CA]">
  //           {nav[4].caption}
  //         </Link>
  //         <Link to={nav[5].href} className="font-medium text-xs text-white font-montserrat hover:text-[#00C6CA]">
  //           {nav[5].caption}
  //         </Link>
  //       </div>}
  //     </div>

  //     <div className="block flex justify-center items-center gap-4 p-0 m-0">
  //       <div className="flex flex-row gap-3">
  //         <a href={footer?.linkedin} target="_"><img className="w-4 h-4" src={linkedIn} alt=""/></a>
  //         <a href={footer?.instagram} target="_"><img className="w-4 h-4" src={insta} alt=""/></a>
  //         <a href={footer?.twitter} target="_"><img className="w-4 h-4" src={twitter} alt=""/></a>
  //         <a href={footer?.youtube} target="_"><img className="w-4 h-4" src={youtube} alt=""/></a>
  //         <a href={footer?.facebook} target="_"><img className="w-4 h-4" src={facebook} alt=""/></a>
  //       </div>

  //       <div className="flex justify-center items-center gap-2 p-0 m-0">
  //         <a href={footer?.google_play} target="_">
  //           <img
  //             className="h-20 hover:cursor-pointer p-0 m-0"
  //             src={gplay}
  //             alt=""
  //           />
  //         </a>
  //       </div>
  //     </div>

  //     <div className="">
  //       {/* <div className="w-full  border border-black border-opacity-40 mt-1"></div> */}
  //       <div className="justify-start flex justify-center pb-2 items-center">
  //         <img className="object-center w-3 h-3 mr-1" src={copyRight} />
  //         <div className="font-light text-white text-xs mr-2 font-montserrat">
  //           Fintra 2023
  //         </div>
  //         <div className="font-light text-white text-xs font-montserrat">
  //           Crafted with
  //         </div>
  //         <img className="object-center w-3 h-3 ml-1" src={heart} />
  //         <div className="font-light text-white text-xs font-montserrat">
  //           in India
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}

export default Footer;
